import TrellisLink from "../../../../components/core/basic/TrellisLink";
import useDSPSellerInfo from "../../../../modules/dsp/hooks/useDSPSellerInfo";
import { Navigate, createFileRoute } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { useAppSelector } from "../../../../redux/hooks";
import { PageContainer } from "../../../../components/core/basic/PageContainer";
import Loading from "../../../../components/core/blocks/Loading";

const DSPAdvertisers = () => {
  const { t } = useTranslation(["dsp"]);
  const { dspAdvertisers, isLoading } = useDSPSellerInfo();
  const { marketPlace } = useAppSelector((state) => state.marketPlace);

  if (isLoading) {
    return <Loading />;
  }

  if (dspAdvertisers?.length === 1) {
    return (
      <Navigate
        to="/user/dsp/$dspAdvertiser/dashboard"
        params={{ dspAdvertiser: String(dspAdvertisers[0].id) }}
        replace
      />
    );
  }
  if (
    dspAdvertisers?.filter((d) => d.marketplace === marketPlace || (marketPlace === "USA" && d.marketplace === "US"))
      .length === 1
  ) {
    const advertiser = dspAdvertisers.find(
      (d) => d.marketplace === marketPlace || (marketPlace === "USA" && d.marketplace === "US"),
    );
    return (
      <Navigate to="/user/dsp/$dspAdvertiser/dashboard" params={{ dspAdvertiser: String(advertiser.id) }} replace />
    );
  }
  return (
    <PageContainer>
      <h3>{t(($) => $.dsp["DSP Profiles"])}</h3>
      {dspAdvertisers?.map((profile) => (
        <div key={profile.id}>
          <TrellisLink to={`/user/dsp/${profile.id}/dashboard`}>
            {profile.id} ({profile.marketplace})
          </TrellisLink>
        </div>
      ))}
    </PageContainer>
  );
};

export const Route = createFileRoute("/_authenticated/user/dsp/")({
  component: DSPAdvertisers,
  staticData: { application: "Advertising" },
});
